import { Tools } from "../Misc/tools.js";
import { SceneComponentConstants } from "../sceneComponent.js";
import { AbstractScene } from "../abstractScene.js";
import { LensFlareSystem } from "./lensFlareSystem.js";
// Adds the parser to the scene parsers.
AbstractScene.AddParser(SceneComponentConstants.NAME_LENSFLARESYSTEM, function (parsedData, scene, container, rootUrl) {
    // Lens flares
    if (parsedData.lensFlareSystems !== undefined && parsedData.lensFlareSystems !== null) {
        if (!container.lensFlareSystems) {
            container.lensFlareSystems = new Array();
        }
        for (var index = 0, cache = parsedData.lensFlareSystems.length; index < cache; index++) {
            var parsedLensFlareSystem = parsedData.lensFlareSystems[index];
            var lf = LensFlareSystem.Parse(parsedLensFlareSystem, scene, rootUrl);
            container.lensFlareSystems.push(lf);
        }
    }
});
AbstractScene.prototype.getLensFlareSystemByName = function (name) {
    for (var index = 0; index < this.lensFlareSystems.length; index++) {
        if (this.lensFlareSystems[index].name === name) {
            return this.lensFlareSystems[index];
        }
    }
    return null;
};
AbstractScene.prototype.getLensFlareSystemById = function (id) {
    for (var index = 0; index < this.lensFlareSystems.length; index++) {
        if (this.lensFlareSystems[index].id === id) {
            return this.lensFlareSystems[index];
        }
    }
    return null;
};
AbstractScene.prototype.getLensFlareSystemByID = function (id) {
    return this.getLensFlareSystemById(id);
};
AbstractScene.prototype.removeLensFlareSystem = function (toRemove) {
    var index = this.lensFlareSystems.indexOf(toRemove);
    if (index !== -1) {
        this.lensFlareSystems.splice(index, 1);
    }
    return index;
};
AbstractScene.prototype.addLensFlareSystem = function (newLensFlareSystem) {
    this.lensFlareSystems.push(newLensFlareSystem);
};
/**
 * Defines the lens flare scene component responsible to manage any lens flares
 * in a given scene.
 */
var LensFlareSystemSceneComponent = /** @class */ (function () {
    /**
     * Creates a new instance of the component for the given scene
     * @param scene Defines the scene to register the component in
     */
    function LensFlareSystemSceneComponent(scene) {
        /**
         * The component name helpful to identify the component in the list of scene components.
         */
        this.name = SceneComponentConstants.NAME_LENSFLARESYSTEM;
        this.scene = scene;
        scene.lensFlareSystems = new Array();
    }
    /**
     * Registers the component in a given scene
     */
    LensFlareSystemSceneComponent.prototype.register = function () {
        this.scene._afterCameraDrawStage.registerStep(SceneComponentConstants.STEP_AFTERCAMERADRAW_LENSFLARESYSTEM, this, this._draw);
    };
    /**
     * Rebuilds the elements related to this component in case of
     * context lost for instance.
     */
    LensFlareSystemSceneComponent.prototype.rebuild = function () {
        for (var index = 0; index < this.scene.lensFlareSystems.length; index++) {
            this.scene.lensFlareSystems[index].rebuild();
        }
    };
    /**
     * Adds all the elements from the container to the scene
     * @param container the container holding the elements
     */
    LensFlareSystemSceneComponent.prototype.addFromContainer = function (container) {
        var _this = this;
        if (!container.lensFlareSystems) {
            return;
        }
        container.lensFlareSystems.forEach(function (o) {
            _this.scene.addLensFlareSystem(o);
        });
    };
    /**
     * Removes all the elements in the container from the scene
     * @param container contains the elements to remove
     * @param dispose if the removed element should be disposed (default: false)
     */
    LensFlareSystemSceneComponent.prototype.removeFromContainer = function (container, dispose) {
        var _this = this;
        if (!container.lensFlareSystems) {
            return;
        }
        container.lensFlareSystems.forEach(function (o) {
            _this.scene.removeLensFlareSystem(o);
            if (dispose) {
                o.dispose();
            }
        });
    };
    /**
     * Serializes the component data to the specified json object
     * @param serializationObject The object to serialize to
     */
    LensFlareSystemSceneComponent.prototype.serialize = function (serializationObject) {
        // Lens flares
        serializationObject.lensFlareSystems = [];
        var lensFlareSystems = this.scene.lensFlareSystems;
        for (var _i = 0, lensFlareSystems_1 = lensFlareSystems; _i < lensFlareSystems_1.length; _i++) {
            var lensFlareSystem = lensFlareSystems_1[_i];
            serializationObject.lensFlareSystems.push(lensFlareSystem.serialize());
        }
    };
    /**
     * Disposes the component and the associated resources.
     */
    LensFlareSystemSceneComponent.prototype.dispose = function () {
        var lensFlareSystems = this.scene.lensFlareSystems;
        while (lensFlareSystems.length) {
            lensFlareSystems[0].dispose();
        }
    };
    LensFlareSystemSceneComponent.prototype._draw = function (camera) {
        // Lens flares
        if (this.scene.lensFlaresEnabled) {
            var lensFlareSystems = this.scene.lensFlareSystems;
            Tools.StartPerformanceCounter("Lens flares", lensFlareSystems.length > 0);
            for (var _i = 0, lensFlareSystems_2 = lensFlareSystems; _i < lensFlareSystems_2.length; _i++) {
                var lensFlareSystem = lensFlareSystems_2[_i];
                if ((camera.layerMask & lensFlareSystem.layerMask) !== 0) {
                    lensFlareSystem.render();
                }
            }
            Tools.EndPerformanceCounter("Lens flares", lensFlareSystems.length > 0);
        }
    };
    return LensFlareSystemSceneComponent;
}());
export { LensFlareSystemSceneComponent };
LensFlareSystem._SceneComponentInitialization = function (scene) {
    var component = scene._getComponent(SceneComponentConstants.NAME_LENSFLARESYSTEM);
    if (!component) {
        component = new LensFlareSystemSceneComponent(scene);
        scene._addComponent(component);
    }
};
//# sourceMappingURL=lensFlareSystemSceneComponent.js.map